import React from 'react';
import { useNamespacedTranslation } from '../../../../../../../hooks/useNamespacedTranslation';

import { NextPeriodSummary } from '../types';
import { AllowanceListItemAccrued } from './AllowanceListItemAccrued';
import { AbsencesHint } from './AbsencesHint';
import { AllowanceListItem } from './AllowanceListItem';

type NextYearPeriodListItemsProps = {
  isUnlimited: boolean;
  summary: NextPeriodSummary;
};

const i18nKey = 'absences.cards.absenceCategories.listItem.nextYear';

const NextYearPeriodListItems: React.FC<
  React.PropsWithChildren<NextYearPeriodListItemsProps>
> = ({
  summary: {
    scheduled,
    willAccrue: willAccur,
    scheduledAbsences,
    allowances,
    name: periodName,
  },
  isUnlimited,
}) => {
  // todo: peropd name
  const namespacedTranslation = useNamespacedTranslation(i18nKey);

  return (
    <>
      <AllowanceListItemAccrued
        isUnlimited={isUnlimited}
        periodType="next"
        amount={willAccur}
        allowances={allowances}
      />
      <AllowanceListItem>
        <small className="d-flex">
          {namespacedTranslation('requested')}
          <AbsencesHint absences={scheduledAbsences} periodName={periodName} />
        </small>
        <small>{scheduled}</small>
      </AllowanceListItem>
    </>
  );
};

export default NextYearPeriodListItems;
